/**
 * Permissões hoje disponiveis no backend, se algum dia for trocado o valor,
 * ou se for adicionado, favor fazer as devidas mudanças.
 */
// permissoesAcoes = [
//     SEPARAR_CARTEIRAS_DE_UNIMEDS,
//     APROVAR_ARQUIVOS,
//     ENVIAR_EMAIL,
//     VISUALIZAR_DOCUMENTOS,
//     GERAR_RELATORIOS,
//     CONSULTAR_DADOS,
//     IMPORTAR_EXPORTAR
// ];
// permissoesTelas = [
//     HOME,
//     VALIDACAO,
//     VALIDACAO_DETALHE,
//     PRESTADORES,
//     PRESTADORES_DETALHE,
//     ADMINISTRACAO,
//     RELATORIOS
// ];

import { enumPermissoesAcoes, enumPermissoesTela } from "./Enum";

/**
 *  Esse arquivo função tem o propósito de centralizar a verificação de permissão no front-end
 */

/**
 * Função que serve pra verificar se o usuário tem acesso a tela descrita.
 * @param {String} tela - Usado como a chave do "enumPermissoesTela", serve para referenciar o enum que o back usa.
 * @param {Array<String>} permissoesTelaUsuario - Array com todas as permissões de tela do usuário.
 * @return {Boolean}
 */
export const contemPermissaoTela = (tela, permissoesTelaUsuario) => {
  return permissoesTelaUsuario.includes(enumPermissoesTela[tela]);
};

/**
 * Função que serve pra verificar se o usuário tem acesso a ação descrita.
 * @param {String} acao - Usado como a chave do "enumPermissoesAcao", serve para referenciar o enum que o back usa.
 * @param {Array<String} permissoesAcaoUsuario - Array com todas as permissões de ação do usuário.
 * @return {Boolean}
 */
export const contemPermissaoAcao = (acao, permissoesAcaoUsuario) => {
  return permissoesAcaoUsuario.includes(enumPermissoesAcoes[acao]);
};
